"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.upgrade.subject': 'Cuenta actualizada exitosamente',
    'email.upgrade.title': '¡Su cuenta ha sido actualizada!',
    'email.upgrade.text': '¡Excelente noticia! Su cuenta ha sido actualizada exitosamente y ahora tiene acceso a funciones mejoradas.',
    'email.upgrade.new_plan': 'Nuevo Plan',
    'email.upgrade.benefits': 'Ahora puede disfrutar de todos los beneficios de su nuevo plan de suscripción.',
    'email.upgrade.dashboard_button': 'Ir al Panel',
    'email.upgrade.footer': '¡Gracias por elegir IntHub!',
};
